
export class TeacherClass {
    TeacherID:string;
    ClassId:string;

    constructor(TeacherID: string, ClassId: string) {
        this.TeacherID = TeacherID;
        this.ClassId = ClassId;
    }
}